export default class SessionStorageHelper {

    // Stores a key/value in session storage.
    public static setSessionStorageParam(key: string, value: any): void {
        if (window.sessionStorage) {
            window.sessionStorage[key] = JSON.stringify(value);
        }
    }

    // Fetches a key from session storage.  Returns undefined if key doesn't exist.
    public static getSessionStorageParam(key: string): any {
        if (window.sessionStorage) {
            if (window.sessionStorage[key] === "undefined" ||
                window.sessionStorage[key] === undefined) {
                return undefined;
            }
            return JSON.parse(window.sessionStorage[key]);
        }
        return undefined;
    }

    // Deletes a key from session storage.
    public static deleteSessionStorageParam(key: string): void {
        if (window.sessionStorage) {
            window.sessionStorage.removeItem(key);
        }
    }

    // Clears all keys from session storage.
    public static clearSessionStorage(): void {
        if (window.sessionStorage) {
            window.sessionStorage.clear();
        }
    }

}
